module.exports = __webpack_public_path__ + "img/ics_o_more.54615150.svg";